"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.shouldLog = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _queue = _interopRequireDefault(require("./queue"));

var _config = require("../config");
/* eslint no-console: 0 */


var logLevels = {};
logLevels.DEBUG = 'debug';
logLevels.INFO = 'info';
logLevels.LOG = 'log';
logLevels.WARN = 'warn';
logLevels.ERROR = 'error';
logLevels.NONE = 'none';
var logLevelsOrder = [logLevels.DEBUG, logLevels.INFO, logLevels.LOG, logLevels.WARN, logLevels.ERROR, logLevels.NONE // don't log anything
];

var shouldLog = function shouldLog(logLevel, globalLogLevel) {
  return logLevelsOrder.indexOf(logLevel) >= logLevelsOrder.indexOf(globalLogLevel);
};

exports.shouldLog = shouldLog;

var _log = function log(msg, logLevel) {
  (0, _queue.default)(function () {
    var _console, _console2, _console3, _console4, _console5, _console6;

    var _getConfig = (0, _config.getConfig)(),
        logLevelThreshold = _getConfig.logLevel,
        onError = _getConfig.onError;

    if (!shouldLog(logLevel, logLevelThreshold)) {
      return;
    }

    var prefix = ['%ctab-ads', 'background: #4fb6ff; color: #fff; border-radius: 2px; padding: 2px 6px'];

    switch (logLevel) {
      case logLevels.DEBUG:
        (_console = console).debug.apply(_console, prefix.concat((0, _toConsumableArray2.default)(msg)));

        break;

      case logLevels.INFO:
        (_console2 = console).info.apply(_console2, prefix.concat((0, _toConsumableArray2.default)(msg)));

        break;

      case logLevels.LOG:
        (_console3 = console).log.apply(_console3, prefix.concat((0, _toConsumableArray2.default)(msg)));

        break;

      case logLevels.WARN:
        (_console4 = console).warn.apply(_console4, prefix.concat((0, _toConsumableArray2.default)(msg)));

        break;

      case logLevels.ERROR:
        onError.apply(void 0, (0, _toConsumableArray2.default)(msg));

        (_console5 = console).error.apply(_console5, prefix.concat((0, _toConsumableArray2.default)(msg)));

        break;

      default:
        (_console6 = console).error.apply(_console6, prefix.concat((0, _toConsumableArray2.default)(msg)));

    }
  });
};

var logger = {
  log: function log() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _log(args, logLevels.LOG);
  },
  debug: function debug() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    _log(args, logLevels.DEBUG);
  },
  info: function info() {
    for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
      args[_key3] = arguments[_key3];
    }

    _log(args, logLevels.INFO);
  },
  warn: function warn() {
    for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
      args[_key4] = arguments[_key4];
    }

    _log(args, logLevels.WARN);
  },
  error: function error() {
    for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
      args[_key5] = arguments[_key5];
    }

    _log(args, logLevels.ERROR);
  }
};
var _default = logger;
exports.default = _default;